<script>
  import classnames from 'classnames';
  export let active = false;
</script>

<span class={classnames('chevron-up', { 'is-active': active })} />

<style lang="scss">
  .chevron-up {
    width: 15px;
    height: 15px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #ddd;
    position: relative;
    top: -10px;
  }

  .chevron-up:hover,
  .chevron-up.is-active {
    border-bottom-color: #aaa;
  }
</style>
